import React, { useState } from "react";
import "./form.css";

const Form = (props) => {
  const [name, setName] = useState("");
  const [village, SetVillage] = useState("");
  const [contact, setContact] = useState("");
  // const [surname, setSurname] = useState("");
  const [image, setImage] = useState("");
  const [showform, setShowform] = useState(true);
  // const [showbutton, setShowbutton] = useState(true);

  const handleName = (event) => {
    setName(event.target.value);
  };

  const handleVillage = (event) => {
    SetVillage(event.target.value);
  };

  const handleContact = (event) => {
    setContact(event.target.value);
  };

  // const handleSurname = (event) => {
  //   setSurname(event.target.value);
  // };

  const handleImage = (e) => {
    const [file] = e.target.files;
    setImage(URL.createObjectURL(file));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    if (
      (name.length === 0 && village.length === 0 && contact.length === 0,
      image.length === 0)
    ) {
      alert(" Enter all Field");
      setShowform(true);
    }
    setShowform(false);
    //  setShowbutton(true);

    // setTimeout(() => {
    //   setShowbutton(true);
    // }, 5000);
  };

  return (
    <>
      {showform && (
        <div className="form">
          <form onSubmit={handleSubmit}>
            <label>
              Enter your name:
              <input
                type="text"
                name="username"
                value={name}
                onChange={handleName}
              />
            </label>
            <label>
              Enter your village:
              <input
                type="text"
                name="villagename"
                value={village}
                onChange={handleVillage}
              />
            </label>
            <label>
              Enter your number:
              <input
                type="tel"
                name="number"
                value={contact}
                onChange={handleContact}
              />
            </label>
            {/* <label>
            Enter your name:
            <input
              type="text"
              name="username"
              value={surname}
              onChange={handleSurname}
            />
          </label> */}
            <label>
              Enter your image:
              <input
                type="file"
                //files="image"
                name="imagename"
                onChange={handleImage}
              />
            </label>
            <button
              type="submit"
              style={{
                color: "white",
                backgroundColor: "red",
                padding: "8px",
                margin: "10px",
                border: "1px solid red",
                borderRadius: "5px",
                width: "35vw",
              }}
            >
              Submit
            </button>
          </form>
        </div>
      )}
      <div className="content">
        <div className="cont1">
          <div className="sardar">
            <div className="img1">
              <img src="/images/2.jpg" alt="" />
            </div>
            <p>||જય સરદાર ||</p>
            <div className="img2">
              <img src="/images/1.jpg" alt="" />
            </div>
          </div>
          <h4>શ્રી સિદપરા પરિવાર સોશ્યલ ગ્રુપ</h4>
        </div>
        <div className="ruler"></div>
        <div className="cont2">
          <div className="img3">
            <img src="/images/3.png" alt="" />
          </div>
          <div className="img4">
            <img src="/images/4.png" alt="" />
          </div>
          <h5>સિદપરા પરિવાર દ્વારા</h5>
          <h3 style={{ color: "green" }}>ભવ્ય ધ્વજારોહણ કાર્યક્રમ</h3>

          <h3 style={{ textDecoration: "underline" }}>શ્રી ખોડલધામ</h3>
        </div>
        <div className="cont3">
          <h5>તા. ૦૮-૦૫-૨૦૨૨, રવિવાર - સમય : સવારે ૬:૩૦ કલાકે</h5>
        </div>

        <div className="cont4">
          <div className="cont42">
            <h5>હું ધ્વજારોહણ માં જોડાવ છું.</h5>
          </div>
          <div className="cont40">
            <div className="cont41">
              <p>{name}</p>
            </div>
            <div className="cont41">
              <p>{village}</p>
            </div>
            <div className="cont41">
              <p>{contact}</p>
            </div>
            <div className="image">
              <img src={image} alt="" />
            </div>
            {/* <div className="cont41">
          <p></p>
        </div> */}
          </div>
        </div>
      </div>

      {/* {showbutton && (
        <button
          type="button"
          style={{
            color: "red",
            backgroundColor: "yellow",
            padding: "8px",
            margin: "10px",
            border: "1px solid red",
            borderRadius: "5px",
            width: "35vw",
          }}
          onClick={() => {
            setShowform(true);
          }}
        >
          Showform
        </button> */}
    </>
  );
};

export default Form;
